export default "__VITE_ASSET__jFFtDGPZ__"